import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const ran = ({ ran: _ran }: VehicleStatsByCompany): string => (_ran && Number.isFinite(ran) ? `${_ran}` : '--')
